import { jsx } from "react/jsx-runtime";
import { forwardRef, useState, useRef, useEffect } from "react";
import { PinCell } from "./styles.js";
import { styled, Box } from "@mui/material";
import cn from "../../../vendor/classnames/index.js";
import { inheritDataTestId } from "../../../utils/dataTestId.js";
import { DATA_TEST_ID_INHERITED } from "../../../constants/DATA_TEST_ID_INHERITED.js";
const CELL_WIDTH = 32, CellContainer = styled(Box)(() => ({
  width: CELL_WIDTH,
  minWidth: `${CELL_WIDTH}px`,
  position: "relative",
  flexShrink: 0,
  height: "100%"
})), NumberPinCell = forwardRef(
  ({
    value: externalValue,
    onChange,
    id,
    index,
    onSelectPrev,
    onSelectNext,
    error,
    onPaste,
    selected,
    success,
    ...props
  }, ref) => {
    const [value, setValue] = useState(externalValue || ""), internalRef = useRef(null), handleChange = (e) => {
      if (e.target.value.length > 2) {
        onPaste == null || onPaste(e.target.value, index);
        return;
      }
      const originalValue = e.target.value, symbol = e.target.selectionStart === 1 ? originalValue.slice(0, 1) : originalValue.slice(-1);
      symbol && isNaN(Number(originalValue)) || !originalValue.trim().length || (onChange == null || onChange(index, symbol), setValue(symbol));
    }, handleKeyDown = (e) => {
      e.key === "ArrowLeft" && (onSelectPrev == null || onSelectPrev(index)), e.key === "ArrowRight" && (onSelectNext == null || onSelectNext(index)), e.key === "Backspace" && (onSelectPrev == null || onSelectPrev(index), onChange == null || onChange(index, ""));
    };
    return useEffect(() => {
      setValue((val) => val !== externalValue && externalValue.length <= 1 ? externalValue : val);
    }, [externalValue]), /* @__PURE__ */ jsx(
      CellContainer,
      {
        onClick: () => {
          var _a;
          (_a = internalRef.current) == null || _a.focus();
        },
        "data-test-id": inheritDataTestId(props, "cell-container"),
        children: /* @__PURE__ */ jsx(
          PinCell,
          {
            "data-test-id": DATA_TEST_ID_INHERITED,
            className: cn({ selected, invalid: !!error, success }),
            autoComplete: "new-password",
            "aria-autocomplete": "none",
            ref: (e) => {
              internalRef.current = e, ref instanceof Function ? ref(e) : ref && (ref.current = e);
            },
            id,
            name: `${String(index)}${Math.random()}`,
            type: "tel",
            inputMode: "decimal",
            onFocus: (e) => {
              e.target.setSelectionRange(1, 1);
            },
            value: externalValue || value,
            onKeyDown: handleKeyDown,
            onChange: handleChange,
            ...props
          }
        )
      }
    );
  }
);
NumberPinCell.displayName = "NumberPinCell";
export {
  NumberPinCell
};
//# sourceMappingURL=NumberPinCell.js.map
